const COUNTRY_REGION_AU = 'Australia'
const COUNTRY_REGION_US = 'US'

export const AU_STATE_NAMES = {
  ACT: 'Australian Capital Territory',
  NSW: 'New South Wales',
  NT: 'Northern Territory',
  QLD: 'Queensland',
  SA: 'South Australia',
  TAS: 'Tasmania',
  VIC: 'Victoria',
  WA: 'Western Australia'
}

export const US_STATE_NAMES = {
  AL: 'Alabama',
  AK: 'Alaska',
  AZ: 'Arizona',
  AR: 'Arkansas',
  CA: 'California',
  CO: 'Colorado',
  CT: 'Connecticut',
  DE: 'Delaware',
  DC: 'District of Columbia',
  FL: 'Florida',
  GA: 'Georgia',
  HI: 'Hawaii',
  ID: 'Idaho',
  IL: 'Illinois',
  IN: 'Indiana',
  IA: 'Iowa',
  KS: 'Kansas',
  KY: 'Kentucky',
  LA: 'Louisiana',
  ME: 'Maine',
  MD: 'Maryland',
  MA: 'Massachusetts',
  MI: 'Michigan',
  MN: 'Minnesota',
  MS: 'Mississippi',
  MO: 'Missouri',
  MT: 'Montana',
  NE: 'Nebraska',
  NV: 'Nevada',
  NH: 'New Hampshire',
  NJ: 'New Jersey',
  NM: 'New Mexico',
  NY: 'New York',
  NC: 'North Carolina',
  ND: 'North Dakota',
  OH: 'Ohio',
  OK: 'Oklahoma',
  OR: 'Oregon',
  PA: 'Pennsylvania',
  RI: 'Rhode Island',
  SC: 'South Carolina',
  SD: 'South Dakota',
  TN: 'Tennessee',
  TX: 'Texas',
  UT: 'Utah',
  VT: 'Vermont',
  VA: 'Virginia',
  WA: 'Washington',
  WV: 'West Virginia',
  WI: 'Wisconsin',
  WY: 'Wyoming'
}

export const REGION_STATES = {
  [COUNTRY_REGION_AU]: Object.keys(AU_STATE_NAMES),
  [COUNTRY_REGION_US]: Object.keys(US_STATE_NAMES)
}

export const getStateNameMap = (tenantCountryRegion) =>
  tenantCountryRegion === COUNTRY_REGION_US ? US_STATE_NAMES : AU_STATE_NAMES

export const formatStateLabel = (stateCode, tenantCountryRegion) => {
  const trimmedStateCode = stateCode?.trim()
  if (!trimmedStateCode) return stateCode

  const stateName = getStateNameMap(tenantCountryRegion)[trimmedStateCode]
  return stateName ? `${trimmedStateCode} - ${stateName}` : trimmedStateCode
}

export const formatRegionDisplayName = (pricingRegion, tenantCountryRegion) => {
  if (!pricingRegion) return ''
  if (tenantCountryRegion === COUNTRY_REGION_US && pricingRegion.state) {
    return formatStateLabel(pricingRegion.state, tenantCountryRegion)
  }
  return pricingRegion.displayName || pricingRegion.name || pricingRegion.code
}

export const buildStateOptions = (
  tenantCountryRegion,
  includeAllOption = null
) => {
  const states =
    REGION_STATES[tenantCountryRegion] || REGION_STATES[COUNTRY_REGION_AU]
  const formattedStates = states.map((state) => ({
    text: formatStateLabel(state, tenantCountryRegion),
    value: state
  }))

  return includeAllOption
    ? [{ text: includeAllOption, value: includeAllOption }, ...formattedStates]
    : formattedStates
}
